import { render, staticRenderFns } from "./refunDetailDialog.vue?vue&type=template&id=af630a56&scoped=true"
import script from "./refunDetailDialog.vue?vue&type=script&lang=js"
export * from "./refunDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./refunDetailDialog.vue?vue&type=style&index=0&id=af630a56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af630a56",
  null
  
)

export default component.exports